import { DatumReader, Datum, SpatialCoordinate, TemporalCoordinate } from '../data-source/types';
import * as util from '../data-source/util';
import { Geometry,SinglePointGeometry,MultiPointGeometry } from '../modeling/modeling-common';

export interface GoiDatum extends Datum {
	name: string,
	types: string[],
	properties: { [key: string]: { [key: string]: any } },
	geometry: (SinglePointGeometry |  MultiPointGeometry) & { xy: number[] | number[][]  }
	size: number,
	isHole:boolean,
	color:string,
    meta:string[],
}

export const goiDataReader: DatumReader = {
	getVersion: (datum: any) => datum.version,
	getTime: (datum: any) => datum.time,
	getStart: (datum: any) => datum.start,
	getEnd: (datum: any) => datum.end,
	getLat: (datum: any) => datum.lat,
	getLng: (datum: any) => datum.lng,
	getNorth: (datum: any) => datum.north,
	getEast: (datum: any) => datum.east,
	getSouth: (datum: any) => datum.south,
	getWest: (datum: any) => datum.west,
	compareByTime: (datum0: TemporalCoordinate, datum1: TemporalCoordinate) => util.compareByTime(datum0, datum1),
	temporalHash: (datum: Datum) => util.datumTemporalHash(datum),
	isTemporal: (datum: any) => util.isTemporal(datum),
	isMoment: (datum: any) => util.isMoment(datum),
	isRange: (datum: any) => util.isRange(datum),
	isPerpetual: (datum: any) => util.isPerpetual(datum),
	isSince: (datum: any) => util.isSince(datum),
	isUntil: (datum: any) => util.isUntil(datum),
	hasStart: (datum: any) => util.hasStart(datum),
	hasEnd: (datum: any) => util.hasEnd(datum),
	getDuration: (datum: any) => util.duration(datum),
	compareByLocation: (datum0: SpatialCoordinate, datum1: SpatialCoordinate) => util.compareByLocation(datum0, datum1),
	spatialHash: (datum: Datum) => util.datumSpatialHash(datum),
	isSpatial: (_datum: any) => true,
	isPoint: (datum: any) => util.isPoint(datum),
	isArea: (datum: any) => util.isArea(datum),
	 isVersional: (_datum: any) => true,
}


